import { initI18n } from 'hive-react-utils';

import { en } from '../i18n/en';

initI18n({ en });
